import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useCallback
} from 'react'
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import {
  Card,
  Fade,
  Paper,
  Stepper,
  Step,
  StepButton,
  Grid,
  Button,
  CircularProgress
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import green from '@material-ui/core/colors/green'
import red from '@material-ui/core/colors/red'
import { useEntityManager, Snackbar, AuthContext, SimpleDialog } from 'elentari'
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import setFieldTouched from 'final-form-set-field-touched'
import solicitacoesEmbarcadorRepository from './solicitacoesEmbarcadorRepository'
import InformacoesForm, {
  validateInformacoes
} from './Informacoes/InformacoesForm'
import MotoristaForm, { validateMotorista } from './Motoristas/MotoristaForm'
import VeiculosForm, { validateVeiculos } from './Veiculos/VeiculosForm'
import ReferenciasForm, {
  validateReferencias
} from './Referencias/ReferenciasForm'
import { anyRequired } from '../../lib/yupValidation'
import * as R from 'ramda'
import ChatCardEmbarcador from '../Chats/ChatCardEmbarcador'
import { StatusEnum } from '../Solicitacoes/components'
import chatRepository from '../Chats/ChatRepository'
import SolicitacaoCard from '../Solicitacoes/SolicitacaoCard'
import { concatObservacao } from '../../utils/ConcatObservacao'
import SolicitacaoPrint from '../Solicitacoes/SolicitacaoPrintProtocolo'
import { DocumentosCard } from '../Documentos'
import documentosRepository from '../Documentos/DocumentosRepository'

const useStyles = makeStyles(theme => ({
  root: {
    padding: 16
  },
  card: {
    marginBottom: theme.spacing(3)
  },
  buttonContainer: {
    width: 160
  },
  buttonContent: {
    width: '100%'
  },
  backButton: {
    marginRight: theme.spacing(1)
  },
  stepper: {
    padding: 12
  },
  stepperPaper: {
    position: 'fixed',
    top: 64,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1050
  },
  form: {
    marginTop: theme.spacing(3)
  },
  stepBtn: {
    padding: '0px 16px'
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    right: 8,
    marginTop: -12,
    marginLeft: -12
  },
  successButton: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[500]
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: green[500]
    }
  },
  errorButton: {
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[500]
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: red[500]
    }
  },
  checkIcon: { marginLeft: 'auto', marginRight: 'auto', fontSize: 20 }
}))

const mapValidators = {
  'Informações gerais': validateInformacoes,
  Motorista: validateMotorista,
  Veículos: validateVeiculos,
  Referências: validateReferencias
}

const getSteps = (isNew, renovado) => {
  const steps = ['Informações gerais', 'Motorista', 'Veículos', 'Referências']
  if (isNew && renovado) {
    steps.pop()
  }
  if (!isNew) {
    steps.push('Comentários')
  }
  steps.push('Documentos')
  return steps
}

function getStepContent(
  stepLabel,
  props,
  values,
  form,
  showError,
  cannotUpdate,
  documentosLocaisProps
) {
  switch (stepLabel) {
    case 'Informações gerais':
      return (
        <InformacoesForm
          {...props}
          values={values}
          form={form}
          showError={showError}
          cannotUpdate={cannotUpdate}
          history={props.history}
        />
      )
    case 'Motorista':
      return (
        <MotoristaForm
          {...props}
          values={values}
          form={form}
          showError={showError}
          cannotUpdate={cannotUpdate}
        />
      )
    case 'Veículos':
      return (
        <VeiculosForm
          {...props}
          values={values}
          form={form}
          showError={showError}
          cannotUpdate={cannotUpdate}
        />
      )
    case 'Referências':
      return (
        <ReferenciasForm
          {...props}
          cannotUpdate={cannotUpdate}
          values={values}
          form={form}
          showError={showError}
        />
      )
    case 'Comentários':
      return (
        <ChatCardEmbarcador
          {...props}
          cannotUpdate={cannotUpdate}
          chatInterno
        />
      )
    case 'Documentos':
      return (
        <DocumentosCard
          key={documentosLocaisProps ? 'locais' : 'remotos'}
          match={props.match}
          {...documentosLocaisProps}
        />
      )
    default:
      return 'Unknown stepIndex'
  }
}

const MiniStepper = props => {
  const { steps, activeStep, elementRef, handleStep, values } = props
  const classes = useStyles()
  const [miniStepper, setMiniStepper] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const position = elementRef.current.getBoundingClientRect()
      if (position.y - 40 < 0 && miniStepper === false) {
        setMiniStepper(true)
        return
      }
      if (position.y - 40 > 0 && miniStepper === true) {
        setMiniStepper(false)
      }
    }
    handleScroll()
    const main = document.getElementsByTagName('main')[0]
    main.addEventListener('scroll', handleScroll)
    return () => {
      main.removeEventListener('scroll', handleScroll)
    }
  }, [miniStepper, elementRef, activeStep])

  return (
    <Fade in={miniStepper}>
      <Card className={classes.stepperPaper}>
        <Stepper className={classes.stepper} activeStep={activeStep} nonLinear>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepButton
                disableRipple
                className={classes.stepBtn}
                onClick={handleStep(values, index)}
              >
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </Card>
    </Fade>
  )
}

const SolicitacoesEmbarcadorForm = props => {
  const classes = useStyles()
  const printRef = useRef()
  const [activeStep, setActiveStep] = useState(0)
  const [mensagem, setMensagem] = useState('')
  const [showError, setShowError] = useState(false)
  const [submitStatus, setSubmitStatus] = useState('edit')
  const [documentosPendentes, setDocumentosPendentes] = useState([])
  const [falhaDocumentos, setFalhaDocumentos] = useState('')
  const documentoEmEdicaoRef = useRef(false)
  const setDocumentoEmEdicao = useCallback(aberto => {
    documentoEmEdicaoRef.current = aberto
  }, [])

  const { id } = useParams()
  const elementRef = useRef()
  const { user } = useContext(AuthContext)

  const entityManager = useEntityManager({
    repository: solicitacoesEmbarcadorRepository
  })

  let composicao = []
  let proprietarioCavalo = {}
  const veiculos = entityManager.item.veiculos ?? []

  if (veiculos.length > 0) {
    composicao = entityManager.item.veiculos.map(v => v.placa)
    proprietarioCavalo = veiculos[0].proprietario
  }

  const cannotUpdate =
    (R.isEmpty(entityManager.item) && !entityManager.isNew) ||
    (!R.isEmpty(entityManager.item) &&
      (!!entityManager.item.dataTermino ||
        entityManager.item?.status !== StatusEnum.PENDENTE))

  const [values, setValues] = useState(entityManager.item)

  useEffect(() => {
    const formatedReferenciasComerciais = entityManager.item.referenciasComerciais?.map(
      referencia => {
        return {
          ...referencia,
          nome: {
            label: referencia.nome,
            value: referencia.transportadoraConfiavelId
              ? referencia.transportadoraConfiavelId
              : referencia.nome,
            id: referencia.transportadoraConfiavelId,
            telefone: referencia.telefone
          }
        }
      }
    )

    setValues({
      ...entityManager.item,
      contratoAgregadoInput: entityManager.item.contratoAgregado,
      grExternaFileInput: entityManager.item.grExternaFile,
      contratoArrendamentoInput: entityManager.item.contratoArrendamento,
      referenciasComerciais: formatedReferenciasComerciais
    })
  }, [entityManager.item])

  const steps = getSteps(entityManager.isNew, values?.renovado)

  const validate = async values => {
    const informacoes = await validateInformacoes(values)
    const motorista = await validateMotorista(values)
    const veiculos = await validateVeiculos(values)
    const referencias = !values.renovado
      ? await validateReferencias(values)
      : null
    return {
      ...informacoes,
      ...motorista,
      ...veiculos,
      ...referencias
    }
  }

  const changeStep = (values, step) => {
    setShowError(false)
    setMensagem('')
    const stepElement = document.getElementById('content')
    setTimeout(() => {
      stepElement.scrollIntoView()
    }, 200)
    setValues(values)
    const newSteps = getSteps(entityManager.isNew, values?.renovado)
    const newStep = newSteps.indexOf(steps[step])
    setActiveStep(newStep >= 0 ? newStep : Math.min(step, newSteps.length - 1))
  }

  const handleStep = (values, step) => async () => {
    const validator = mapValidators[steps[activeStep]]
    if (validator) {
      const valid = cannotUpdate || anyRequired(await validator(values))
      if (valid || step <= activeStep) {
        changeStep(values, step)
      } else {
        setMensagem(
          values?.motorista?.importadoKMM
            ? 'Existem campos obrigatórios não preenchidos, caso necessário atualize o cadastro no KMM.'
            : 'Existem campos obrigatórios não preenchidos'
        )
        setShowError(true)
      }
    } else {
      changeStep(values, step)
    }
  }

  const save = async (data, files) => {
    if (/new/.test(id)) {
      return solicitacoesEmbarcadorRepository.createSolicitacao(data, files)
    }
    delete data.solicitacao.responsavel
    delete data.solicitacao.centroCusto
    return solicitacoesEmbarcadorRepository.update({ id: +id, ...data })
  }

  const handleSubmitReanalise = async handleSubmit => {
    await handleSubmit()
    const response = await chatRepository.reanaliseByJWT(props.match.params.id)
    if (response.ok) {
      setMensagem('Solicitação enviada para reanalise!')
    } else {
      setMensagem(response.data.error.message)
    }
    await entityManager.getItem()
  }

  const unmask = value => value.replace(/\W/g, '')

  const anexarDocumentos = async (solicitacaoId, documentos) => {
    const falhas = []
    for (const { descricao, fileName, file } of documentos) {
      let motivo
      try {
        const response = await documentosRepository.uploadDocumento(
          solicitacaoId,
          { descricao, fileName },
          file
        )
        if (!response.ok) {
          motivo = R.pathOr('', ['data', 'error', 'message'], response)
          falhas.push({ descricao, motivo })
        }
      } catch (error) {
        falhas.push({ descricao, motivo: error?.message })
      }
    }
    return falhas
  }

  const getMensagemFalhaDocumentos = falhas => {
    const quantidade =
      falhas.length === 1
        ? '1 documento não foi anexado'
        : `${falhas.length} documentos não foram anexados`
    const detalhes = falhas
      .map(({ descricao, motivo }) =>
        motivo ? `${descricao} (${motivo})` : descricao
      )
      .join('; ')
    return `Solicitação criada, mas ${quantidade}: ${detalhes}. Reenvie pela aba Documentos.`
  }

  const handleSubmit = async data => {
    if (documentoEmEdicaoRef.current) {
      setMensagem(
        'Há um documento em preenchimento. Clique em Adicionar para incluí-lo ou em Voltar para descartá-lo.'
      )
      return
    }
    setValues(data)
    const {
      motorista,
      veiculos,
      referenciasPessoais,
      referenciasComerciais,
      ...solicitacao
    } = data
    const referenciasPessoaisObj = referenciasPessoais
      ? {
          referenciasPessoais: referenciasPessoais.map((r, index) => ({
            ...r,
            identificador: index
          }))
        }
      : {}

    const referenciasComerciaisObj = referenciasComerciais
      ? {
          referenciasComerciais: referenciasComerciais.map((r, index) => ({
            ...r,
            identificador: index,
            nome: r.nome.label,
            transportadoraConfiavelId: r.nome.id
          }))
        }
      : {}
    const submitData = {
      solicitacao: {
        ...solicitacao,
        valorCarga: solicitacao.valorCarga,
        cpfRenovacao: solicitacao.cpfRenovacao
          ? unmask(solicitacao.cpfRenovacao)
          : undefined,
        placaRenovacao: solicitacao.placaRenovacao
          ? unmask(solicitacao.placaRenovacao).toUpperCase()
          : undefined,
        observacaoInformacoesGerais: concatObservacao(
          solicitacao.observacaoInformacoesGerais,
          solicitacao.novaObservacaoInformacoesGerais,
          user.name
        ),
        observacaoContatoMotorista: concatObservacao(
          solicitacao.observacaoContatoMotorista,
          solicitacao.novaObservacaoContatoMotorista,
          user.name
        ),
        observacaoMotorista: concatObservacao(
          solicitacao.observacaoMotorista,
          solicitacao.novaObservacaoMotorista,
          user.name
        ),
        observacaoVeiculos: concatObservacao(
          solicitacao.observacaoVeiculos,
          solicitacao.novaObservacaoVeiculos,
          user.name
        ),
        observacaoContatoProprietario: concatObservacao(
          solicitacao.observacaoContatoProprietario,
          solicitacao.novaObservacaoContatoProprietario,
          user.name
        ),
        observacaoReferencias: concatObservacao(
          solicitacao.observacaoReferencias,
          solicitacao.novaObservacaoReferencias,
          user.name
        )
      },
      motorista: {
        ...motorista,
        cpf: unmask(motorista.cpf),
        rg: unmask(motorista.rg),
        cpfMae: unmask(motorista.cpfMae),
        cpfPai: motorista.cpfPai ? unmask(motorista.cpfPai) : ''
      },
      veiculos: veiculos
        .filter(v => v && !R.isEmpty(v))
        .map((v, index) => ({
          ...v,
          placa: unmask(v.placa),
          posicao: index,
          identificador: index
        })),
      ...referenciasPessoaisObj,
      ...referenciasComerciaisObj
    }
    const files = {
      cnh: motorista.cnhImage,
      foto: motorista.foto,
      crlvs: veiculos.filter(v => v && !R.isEmpty(v)).map(v => v.crlvImage),
      comprovanteEndereco: motorista.comprovanteEndereco
        ? motorista.comprovanteEndereco
        : undefined,
      contratoAgregado: solicitacao.contratoAgregadoInput
        ? solicitacao.contratoAgregadoInput
        : undefined,
      grExternaFile: solicitacao.grExternaFileInput
        ? solicitacao.grExternaFileInput
        : undefined,
      contratoArrendamento: solicitacao.contratoArrendamentoInput
        ? solicitacao.contratoArrendamentoInput
        : undefined,
      comprovanteViagens: solicitacao.comprovanteViagensInput
        ? solicitacao.comprovanteViagensInput
        : undefined
    }
    delete submitData.solicitacao.contratoAgregadoInput
    delete submitData.solicitacao.grExternaFileInput
    delete submitData.solicitacao.contratoArrendamentoInput
    delete submitData.solicitacao.comprovanteViagensInput
    delete submitData.solicitacao.novaObservacaoInformacoesGerais
    delete submitData.solicitacao.novaObservacaoMotorista
    delete submitData.solicitacao.novaObservacaoContatoMotorista
    delete submitData.solicitacao.novaObservacaoVeiculos
    delete submitData.solicitacao.novaObservacaoContatoProprietario
    delete submitData.solicitacao.novaObservacaoReferencias
    delete submitData.motorista.cnhImageInput
    delete submitData.motorista.fotoInput
    submitData.veiculos.forEach(veiculo => {
      delete veiculo.crlvImageInput
    })
    const isCreate = /new/.test(id)
    const response = await save(submitData, files)
    if (response.ok) {
      let falhasDocumentos = []
      if (isCreate && documentosPendentes.length) {
        falhasDocumentos = await anexarDocumentos(
          response.data.id,
          documentosPendentes
        )
      }
      setSubmitStatus('success')
      if (isCreate) {
        setDocumentosPendentes([])
        const documentosIndex = steps.indexOf('Documentos')
        setActiveStep(atual =>
          atual === documentosIndex
            ? getSteps(false).indexOf('Documentos')
            : atual
        )
      }
      if (falhasDocumentos.length) {
        setFalhaDocumentos(getMensagemFalhaDocumentos(falhasDocumentos))
      }
      props.history.replace(
        props.history.location.pathname.replace(
          /new$|new-child$/,
          response.data.id
        )
      )
      setTimeout(() => setSubmitStatus('edit'), 2000)
    } else {
      setSubmitStatus('error')
      setTimeout(() => setSubmitStatus('edit'), 2000)
      setMensagem(
        R.pathOr(
          'Ops, algo deu errado!',
          ['data', 'error', 'message'],
          response
        )
      )
    }
  }

  const handleNext = values => {
    handleStep(values, activeStep + 1)()
  }

  const handleBack = values => {
    handleStep(values, activeStep - 1)()
  }

  const getButtonClass = submitStatus => {
    switch (submitStatus) {
      case 'success':
        return classes.successButton
      case 'edit':
        return classes.button
      case 'error':
        return classes.errorButton
      default:
        throw Error('Unexpected formState')
    }
  }

  const getButtonLabel = submitting => {
    if (submitting) {
      return (
        <div>
          <CircularProgress size={24} className={classes.buttonProgress} />
          Enviando
        </div>
      )
    }
    switch (submitStatus) {
      case 'success':
        return (
          <>
            <CheckCircleIcon className={classes.checkIcon} key="successIcon" />
            Sucesso
          </>
        )
      case 'edit':
        if (entityManager.isNew) return 'Enviar'
        else return 'Salvar'
      case 'error':
        return 'Ops, algo deu errado!'
      default:
        throw Error('Unexpected formState')
    }
  }
  return (
    <div {...props} className={classes.root} id="content">
      {!entityManager.isNew && (
        <div className={classes.card}>
          <SolicitacaoCard
            printRef={printRef}
            empresa={entityManager.item?.empresa?.sigla}
            nomeMotorista={entityManager.item?.motorista?.nome}
            cpfMotorista={entityManager.item?.motorista?.cpf}
            nomeEmbarcador={entityManager.item?.nomeEmbarcador}
            nomeProprietario={proprietarioCavalo?.nomeRazaoSocial}
            cpfCnpjProprietario={proprietarioCavalo?.cpfcnpj}
            mercadoria={entityManager.item?.mercadoria?.descricao}
            cliente={entityManager.item?.cliente}
            valorCarga={entityManager.item?.valorCarga}
            centroCusto={entityManager.item?.centroCusto}
            dataTermino={entityManager.item?.dataTermino}
            status={entityManager.item?.status}
            composicao={composicao}
          />
        </div>
      )}
      <Form
        {...props}
        {...entityManager}
        onSubmit={handleSubmit}
        validate={validate}
        initialValues={{
          ...values,
          ddr: values.ddr || false,
          paisOrigem: 'Brasil',
          paisDestino: 'Brasil'
        }}
        mutators={{ ...arrayMutators, setFieldTouched }}
      >
        {({ handleSubmit, submitting, pristine, values, form }) => (
          <form onSubmit={handleSubmit}>
            <Grid direction="column" container spacing={2}>
              <Grid item>
                <>
                  <MiniStepper
                    elementRef={elementRef}
                    steps={steps}
                    activeStep={activeStep}
                    handleStep={(values, index) => handleStep(values, index)}
                    values={values}
                  />
                  <Card>
                    <Stepper activeStep={activeStep} nonLinear>
                      {steps.map((label, index) => (
                        <Step key={label}>
                          <StepButton onClick={handleStep(values, index)}>
                            {label}
                          </StepButton>
                        </Step>
                      ))}
                    </Stepper>
                  </Card>
                  <Paper ref={elementRef} className={classes.form}>
                    {getStepContent(
                      steps[activeStep],
                      props,
                      values,
                      form,
                      showError,
                      cannotUpdate,
                      entityManager.isNew
                        ? {
                            documentosLocais: documentosPendentes,
                            onChangeDocumentosLocais: setDocumentosPendentes,
                            onChangeFormularioAberto: setDocumentoEmEdicao,
                            cannotUpdate: submitting
                          }
                        : undefined
                    )}
                  </Paper>
                  <Snackbar
                    message={mensagem}
                    onClose={() => setMensagem('')}
                  />
                </>
              </Grid>
              <Grid item xs={12} className={classes.buttonContent}>
                <Grid justifyContent="flex-end" container spacing={2}>
                  <Grid item classes={{ item: classes.buttonContainer }}>
                    <Button
                      fullWidth
                      type="button"
                      variant="outlined"
                      disabled={submitting}
                      onClick={() => {
                        const goBack = props.history.location.pathname
                          .split('/')
                          .filter(p => !!p)
                          .slice(0, -1)
                          .join('/')
                        props.history.push('/' + goBack)
                      }}
                    >
                      Voltar
                    </Button>
                  </Grid>
                  <Grid item classes={{ item: classes.buttonContainer }}>
                    <Button
                      fullWidth
                      variant="outlined"
                      disabled={activeStep === 0}
                      onClick={() => handleBack(values)}
                      color="primary"
                    >
                      Anterior
                    </Button>
                  </Grid>
                  <Grid item classes={{ item: classes.buttonContainer }}>
                    <Button
                      fullWidth
                      variant="outlined"
                      disabled={activeStep === steps.length - 1}
                      onClick={() => handleNext(values)}
                      color="primary"
                    >
                      Próximo
                    </Button>
                  </Grid>
                  <Grid item classes={{ item: classes.buttonContainer }}>
                    <Button
                      data-testid="salvar"
                      className={getButtonClass(submitStatus)}
                      fullWidth
                      type="submit"
                      disabled={submitting || cannotUpdate}
                      variant="contained"
                      color="primary"
                    >
                      {getButtonLabel(submitting)}
                    </Button>
                  </Grid>
                  {values.status === StatusEnum.PENDENTE && (
                    <Grid item classes={{ item: classes.buttonContainer }}>
                      <Button
                        data-testid="reanalise"
                        fullWidth
                        disabled={submitting || cannotUpdate}
                        variant="contained"
                        color="secondary"
                        onClick={() => handleSubmitReanalise(handleSubmit)}
                      >
                        Reanálise
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </form>
        )}
      </Form>
      <Snackbar message={mensagem} onClose={() => setMensagem('')} />
      <SimpleDialog
        open={!!falhaDocumentos}
        title="Documentos não anexados"
        message={falhaDocumentos}
        handleClose={() => setFalhaDocumentos('')}
      />
      <div hidden>
        <Grid ref={printRef}>
          <SolicitacaoPrint item={entityManager.item} />
        </Grid>
      </div>
    </div>
  )
}

export default SolicitacoesEmbarcadorForm
